import { matchPath } from 'react-router-dom';

import { createSelector } from '@reduxjs/toolkit';
import { NatalieRoutes } from 'pages/Natalie/routes';

import { natalieEventApi } from './natalieEventApi';

import type { RootState } from 'store';

const selectNatalieEventId = (state: RootState) => {
  const pathname = state.router.location?.pathname;
  if (!pathname) return undefined;

  const match = matchPath<{ id: string }>(pathname, [
    NatalieRoutes.BeforeJoin,
    NatalieRoutes.Details,
    NatalieRoutes.Join,
    NatalieRoutes.Room,
    NatalieRoutes.WaitingRoom,
  ]);

  return match ? match.params.id : undefined;
};

export const selectNatalieEventChannelName = createSelector(
  (state: RootState) => {
    const id = selectNatalieEventId(state);
    if (!id) return undefined;
    return natalieEventApi.endpoints.getToken.select(id)(state);
  },
  (tokenResult) => tokenResult?.data?.channelName
);

export const selectCurrentNatalieEvent = createSelector(
  (state: RootState) => {
    const id = selectNatalieEventId(state);
    if (!id) return undefined;
    return natalieEventApi.endpoints.getNatalieEvent.select(id)(state);
  },
  (eventResult) => eventResult?.data
);
